import { withRouter } from 'react-router';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, setDisplayName, onlyUpdateForKeys, withProps } from 'recompose';
import * as React from 'react';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { withClassname } from '@components/hoc/withClassname';
import { JobsForm } from '@modules/jobs/JobsForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const jobsUrl = '/metropolis/api/jobs';
export const jobsLabel = 'Notifikace';
export const jobsPath = '/administration/jobs';
export const jobsGridName = 'JobsGrid';
export const JobsGrid = compose(
  withRouter,
  setDisplayName(jobsGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: jobsLabel }]),
  withColumns(Agenda.JOBS),
  withProps(({ columns }) => ({
    name: jobsGridName,
    url: jobsUrl,
    Form: JobsForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: true,
      pageSize: 50,
      version: 7,
      ActionBar: () => <ColumnManager agenda={Agenda.JOBS} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/jobs/JobsGrid.tsx